import { Box, Card, CardContent, Typography } from "@mui/material";
import React from "react";
import RoleCard from "./RoleCard";
import { projectRoles } from "../../roles";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";

export default function UsersSection({ project, companyUsers }) {
  const getOldSelectedUsers = (role) => {
    const initialSelectedUsers = projectRoles.map((r) => {
      const roleUsers = [];

      project.usersProjects.forEach((u) => {
        u.roles.includes(r.label) && roleUsers.push(u);
      });

      return { role: r.label, users: roleUsers };
    });

    const oldSelectedUsers =
      initialSelectedUsers
        .find((r) => r.role === role)
        ?.users?.map((u) => u.user) || [];

    console.log(role, oldSelectedUsers);
    return oldSelectedUsers;
  };

  const getRoleUsers = (roleId) => {
    const res = companyUsers.filter((u) => u?.roles?.includes(roleId));

    return res || [];
  };
  return (
    <Box sx={{}}>
      <Typography variant="h6">Project ({project.name}) Members:</Typography>
      <Box sx={{ display: "flex", gap: 2, p: 2, flexWrap: "wrap" }}>
        {projectRoles.map((role) => (
          <Card
            key={role.id}
            sx={{ flexGrow: 1, backgroundColor: "hsla(250, 86%, 97%, 1)" }}
          >
            <CardContent>
              <Typography variant="h6">{role.label}</Typography>
              <Typography
                variant="body2"
                color="text.secondary"
                sx={{
                  cursor: "pointer",
                  fontStyle: "italic",
                  "&:hover": {
                    textDecoration: "underline",
                  },
                }}
              >
                <InfoOutlinedIcon
                  size="small"
                  sx={{ fontSize: "14px", transform: "translateY(2px)" }}
                />
                Info about this role.
              </Typography>

              <RoleCard
                role={role.label}
                project={project}
                roleUsers={getRoleUsers(role.label)}
                oldSelectedUser={getOldSelectedUsers(role.label)}
              />
            </CardContent>
          </Card>
        ))}
      </Box>
    </Box>
  );
}
